import { LoaderFunction } from "react-router-dom";
import { getSearchQuery } from "../query.ts";
import { searchExplore } from "../../../../common/api/bridge/methods.ts";
import {
  CompositeAsset,
  Favorite,
} from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { getFavoritesByVbid } from "../../../../common/api/decimal/methods/favorites.ts";
import { bridgeAssetToCompositeAsset } from "../../../../common/api/bridge/utils.ts";

export interface SearchTitlesExploreData {
  totalItems: number;
  page: number;
  totalPages: number;
  results: CompositeAsset<"explore" | "favorite">[];
}

export const searchTitlesExploreLoader: LoaderFunction = async ({
  request,
}): Promise<SearchTitlesExploreData> => {
  const url = new URL(request.url);
  const query = getSearchQuery(url.searchParams);
  if (query) {
    const page = Number(url.searchParams.get("page"));
    const size = Number(url.searchParams.get("size"));
    const exploreResponse = await searchExplore(
      query,
      isNaN(page) ? undefined : page,
      isNaN(size) ? undefined : size
    );
    const hasResults = exploreResponse?.content.length > 0;
    if (hasResults) {
      const totalItems = exploreResponse.totalElements ?? 0;
      const totalPages = exploreResponse.totalPages ?? 0;
      const page = exploreResponse.page ?? 0;

      const compositeResults = exploreResponse.content.map((asset) =>
        bridgeAssetToCompositeAsset(asset)
      );
      const vbids = compositeResults.map((result) => result.manageAsset.vbid);
      const favoritesResponse = await getFavoritesByVbid(vbids);
      const favorites =
        favoritesResponse.ok && favoritesResponse.data
          ? favoritesResponse.data
          : {};
      const results = compositeResults.map<
        CompositeAsset<"explore" | "favorite">
      >((result) => ({
        ...result,
        favorite: {
          isFavorited: favorites[result.manageAsset.vbid].isFavorited,
        } as Favorite,
      }));
      return Promise.resolve({ totalItems, totalPages, page, results });
    }
  }
  return Promise.resolve({
    totalItems: 0,
    totalPages: 0,
    page: 0,
    results: [],
  });
};
